import { useQuery } from 'hooks/useQuery'

import { fetchSubscriptionsByUserId } from 'utils/queries'

import { Subscription } from 'types/subscription'

/**
 * Fetches all subscriptions for a given user.
 * @param userId The ID of the user to fetch subscriptions for.
 * @returns An array of Subscriptions.
 */
export const useClientSubscriptions = ({ userId }: { userId?: string }) => {
  const subscriptionsQuery = useQuery<Array<Subscription>>(
    ['userSubscriptions', userId],
    () => fetchSubscriptionsByUserId({ id: userId }),
    {
      enabled: !!userId,
    },
  )

  return subscriptionsQuery
}
